<template>
    <div class="article-contact">
        <p>Please feel free get in touch.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
